import { autoConvertToTimezone, convertFromTimezone, convertToTimezone, getDateFromDateTime } from "./dateTimeUtils";
import { DateTime } from "luxon";

export default {
    methods: {
        convertToTimezone(dateTime, targetTimezone, format = "yyyy-MM-dd HH:mm:ss") {
            return convertToTimezone(dateTime, targetTimezone, format);
        },
        convertFromTimezone(dateTime, sourceTimezone) {
            return convertFromTimezone(dateTime, sourceTimezone);
        },
        autoConvertToTimezone(dateTime, format = "yyyy-MM-dd HH:mm:ss") {
            return autoConvertToTimezone(dateTime, format);
        },

        getDateFromDateTime(dateTime) {
            return getDateFromDateTime(dateTime);
        },
        dateRange(startDate, endDate, timezone, format = "yyyy-MM-dd") {
            const startDateObj = DateTime.fromSQL(startDate, { zone: "UTC" });
            const endDateObj = DateTime.fromSQL(endDate, { zone: "UTC" });

            if (endDateObj.toUnixInteger() - startDateObj.toUnixInteger() <= 24 * 60 * 60) {
                return this.convertToTimezone(startDate, timezone, format);
            }

            const formattedStart = this.convertToTimezone(startDate, timezone, format);
            const formattedEnd = this.convertToTimezone(endDate, timezone, format);

            return `${formattedStart} - ${formattedEnd}`;
        },
    },
};
